import React, { useRef } from "react";
import { IMask, IMaskInput } from "react-imask";

export default function CurrencyInput({ onChange }) {
  const ref = useRef(null);
  const inputRef = useRef(null);
  const currencyMask = IMask.createMask({
    mask: "$num",
    blocks: {
      num: {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: ",",
        radix: ".",
      },
    },
  });
  return (
    <IMaskInput
      mask={currencyMask}
      unmask={true} // true|false|'typed'
      ref={ref}
      inputRef={inputRef} // access to nested input
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={
        // depending on prop above first argument is
        // `value` if `unmask=false`,
        // `unmaskedValue` if `unmask=true`,
        // `typedValue` if `unmask='typed'`
        (value, mask) => onChange(value)
      }
    />
  );
}
